import React from 'react';
import { FiArrowUp } from 'react-icons/fi';

export default function Footer() {
  const scrollToTop = () => {
    const el = document.getElementById('home');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-dark py-8 text-light">
      <div className="flex md:flex-row flex-col justify-between items-center mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <p className="mb-4 md:mb-0 text-sm md:text-left text-center">
          © {new Date().getFullYear()} Martin Rygl. Všechna práva vyhrazena.
        </p>

        <button
          onClick={scrollToTop}
          aria-label="Zpět nahoru"
          className="bg-primary hover:bg-primary/90 shadow-lg p-2 rounded-full text-light transition"
        >
          <FiArrowUp size={20} />
        </button>
      </div>
    </footer>
  );
}
